import { render } from "./TimeSlotItemResources.vue?vue&type=template&id=68adbf91&scoped=true&ts=true"
import script from "./TimeSlotItemResources.vue?vue&type=script&lang=ts"
export * from "./TimeSlotItemResources.vue?vue&type=script&lang=ts"

import "./TimeSlotItemResources.vue?vue&type=style&index=0&id=68adbf91&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68adbf91"]])

export default __exports__